//Antd
// eslint-disable-next-line
import { TwitterOutlined, FacebookFilled, InstagramOutlined, YoutubeFilled } from '@ant-design/icons';

// Components
import { BaseLabel } from 'components';

// Styles
import './styles.scss';

const LayoutDefaultFooter = () => {
  return (
    <footer>
      <div className="layout-default-footer flex flex-col items-center justify-center text-center p-10">
        <div className="mb-2">
          <BaseLabel label="Lembaga Sertifikasi Profesi Astra" fontSize={14} isBold />
        </div>
        <BaseLabel label={`Gedung AMDI A`} fontSize={14} />
        <BaseLabel label={`Jl. Gaya Motor Raya No. 8, Sunter II - Jakarta Utara 14330`} fontSize={14} />
        <BaseLabel label={`021-6522 555, ext. 557`} fontSize={14} />
        {/* <div className="mt-2">
          <BaseLabel label={'Temukan Kami di:'} fontSize={14} isBold />
          <div className="mt-2 flex flex-row items-center justify-center text-center">
            <a href="https://twitter.com/satu_indonesia" target="_blank" rel="noreferrer">
              <TwitterOutlined className="icon" />
            </a>
            <div className="ml-3">
              <a href="https://www.facebook.com/semangatastraterpadu/" target="_blank" rel="noreferrer">
                <FacebookFilled className="icon" />
              </a>
            </div>
            <div className="ml-3">
              <a href="https://www.instagram.com/SATU_indonesia/" target="_blank" rel="noreferrer">
                <InstagramOutlined className="icon" />
              </a>
            </div>
            <div className="ml-3">
              <a href="https://www.youtube.com/" target="_blank" rel="noreferrer">
                <YoutubeFilled className="icon" />
              </a>
            </div>
          </div>
        </div> */}
      </div>
      <div className="text-center py-3 copyright-text">
        Copyright &#169;{new Date().getFullYear()} LSP Astra | {' '}
        <a 
          href="https://www.astra.co.id/privacy-policy" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-primary hover:font-weight-700 hover:text-blue-800 underline"
        >
          Kebijakan Privasi
        </a>
      </div>
    </footer>
  );
};

export { LayoutDefaultFooter };
